import { render, staticRenderFns } from "./EmbeddedCard.vue?vue&type=template&id=10250acc&"
import script from "./EmbeddedCard.vue?vue&type=script&lang=js&"
export * from "./EmbeddedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports